import { NgModule } from '@angular/core';

import { GuideModule } from '../../shared-components/guide/guide.module';

import { AutoLotsFilterGuideService } from './services/auto-lots-filter-guide.service';

@NgModule({
  imports: [GuideModule],
  providers: [AutoLotsFilterGuideService],
})
export class AutoLotsFilterGuideModule {}
